// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"e65fc05d","37":"e871d261","126":"55122057","147":"3cd8f560","171":"e2e75dfd","374":"60df79bb","388":"b4b6d0c3","466":"92d4ebb8","507":"4f30852d","780":"abb8869e"}[chunkId] + ".chunk.js";
};